import store from "@/store";

function readCookie(name) {
    var result = decodeURIComponent(document.cookie).match(new RegExp(name + '=([^;]+)'));
    result && (result = JSON.parse(result[1]));
    return result;
}

export default {
    async SEND_AUTH({commit}, credentials) {
        await store.dispatch('customRequests/POST', {
            path: '/auth/login',
            data: credentials
        }).then(async response => {
            commit('SET_AUTH', true)
            commit('SET_COOKIE_TOKEN', response.data.token)
            commit('SET_COOKIE_USER', response.data.user)
        }).catch(e => {
            throw e
        })
    },
    async SEND_GUEST_AUTH({commit}, cid) {
        await store.dispatch('customRequests/POST', {
            path: `/auth/login-guest`,
            data: {cid: cid}
        }).then(response => {
            commit('SET_AUTH', true)
            commit('SET_COOKIE_TOKEN', response.data.token)
            commit('SET_COOKIE_USER', response.data.user)
        }).catch(e => {
            throw e
        })
    },
    async SEND_YANDEX_AUTH({commit}, {code, cid}) {
        await store.dispatch('customRequests/GET', {
            path: '/auth/login-yandex-callback',
            params: {
                code: code,
                cid: cid
            }
        }).then(async response => {
            commit('SET_AUTH', true)
            commit('SET_COOKIE_TOKEN', response.data.token)
            commit('SET_COOKIE_USER', response.data.user)
        }).catch(e => {
            throw e
        })
    },
    async SEND_GOOGLE_AUTH({commit}, {code, cid}) {
        await store.dispatch('customRequests/GET', {
            path: '/auth/login-google-callback',
            params: {
                code: code,
                cid: cid
            }
        }).then(async response => {
            commit('SET_AUTH', true)
            commit('SET_COOKIE_TOKEN', response.data.token)
            commit('SET_COOKIE_USER', response.data.user)
        }).catch(e => {
            throw e
        })
    },
    async SEND_VK_AUTH({commit}, {code, cid}) {
        await store.dispatch('customRequests/GET', {
            path: '/auth/login-vk-callback',
            params: {
                code: code,
                cid: cid
            }
        }).then(async response => {
            commit('SET_AUTH', true)
            commit('SET_COOKIE_TOKEN', response.data.token)
            commit('SET_COOKIE_USER', response.data.user)
        }).catch(e => {
            throw e
        })
    },
    SET_AUTH_DATA({commit, dispatch}) {
        const token = readCookie('token')
        const user = readCookie('user')
        // нужно, чтобы expiresIn (12 часов) на бэке и setCookie на фронте (12 часов) всегда совпадало. TODO подумать, как(отсылать время жизни с бэка?)
        if (token && user) {
            commit('SET_AUTH', true)
            commit('SET_TOKEN', token)
            commit('SET_USER', user)
        } else {
            dispatch('LOGOUT')
        }
    },
    // async CHECK_AUTH ({ dispatch }) {
    //   // TODO добавить обновление данных юзера по токену(получить оттуда id и загрузить юзера из БД) и исключить проверку по localstorage
    //   dispatch('SET_AUTH_DATA')
    //   // await axios.get('/auth/checklogin')
    //   //   .catch(e => {
    //   //     if (e.response.status === 401) {
    //   //       dispatch('LOGOUT')
    //   //     } else {
    //   //       throw e
    //   //     }
    //   //   })
    // },

    async GET_USER_ROLE({commit}) {
        await store.dispatch('customRequests/GET', {
            path: '/roles/user-role',
        }).then(async response => {
            commit('SET_ROLE', response.data)
        })
    },
    LOGOUT({commit}) {
        commit('SET_AUTH', false)
    },
}